const roles = {
  /** @description MENU ADMINISTRAÇÃO */
  MENU_ADMINISTRATION: 'MENU_ADMINISTRATION',
  /** @description MENU FINANCEIRO */
  MENU_FINANCIAL: 'MENU_FINANCIAL',
  /** @description MENU OPERACIONAL */
  MENU_OPERATIONAL: 'MENU_OPERATIONAL',
  /** @description MENU OPERACIONAL */
  MENU_REALSTATE: 'MENU_REALSTATE',

  /** @description ADM - CONTAS */
  RW_ADM_ACCOUNTS: 'RW_ADM_ACCOUNTS',
  /** @description ADM - GRUPOS */
  RW_ADM_GROUPS: 'RW_ADM_GROUPS',
  /** @description ADM - PERMISSÕES */
  RW_ADM_PERMISSIONS: 'RW_ADM_PERMISSIONS',
  RW_ADM_PERMISSIONS_PCI: 'RW_ADM_PERMISSIONS_PCI',

  /** @description FIN - QUADRO FUNCIONÁRIOS */
  RW_FIN_BOARD: 'RW_FIN_BOARD',
  RW_FIN_BOARD_RH: 'RW_FIN_BOARD_RH',
  RW_FIN_BOARD_COORD: 'RW_FIN_BOARD_COORD',

  /** @description OPER - DOCUMENTOS */
  RW_OPER_DOCUMENTS: 'RW_OPER_DOCUMENTS',

  RW_OPER_PCI: 'RW_OPER_PCI',
  RW_OPER_PCI_ADM: 'RW_OPER_PCI_ADM',
  RW_OPER_PCI_ITEM: 'RW_OPER_PCI_ITEM',
  RW_OPER_PCI_ITEM_DEL: 'RW_OPER_PCI_ITEM_DEL',
  RW_OPER_PCI_WORK: 'RW_OPER_PCI_WORK',
  RW_OPER_PCI_TEAM: 'RW_OPER_PCI_TEAM',
  R_OPER_PCI_TEAM: 'R_OPER_PCI_TEAM',
  RW_OPER_PCI_BILLS: 'RW_OPER_PCI_BILLS',
  RW_OPER_PCI_PURCHASE: 'RW_OPER_PCI_PURCHASE',
  RW_OPER_PCI_STOPPAGE: 'RW_OPER_PCI_STOPPAGE',
  RW_OPER_PCI_EVALUATION: 'RW_OPER_PCI_EVALUATION',
  RW_OPER_PCI_EVALUATION_APPROVE: 'RW_OPER_PCI_EVALUATION_APPROVE',
  RW_OPER_PCI_UPLOAD_XLS: 'RW_OPER_PCI_UPLOAD_XLS',
  RW_OPER_PCI_DOCUMENTATION: 'RW_OPER_PCI_DOCUMENTATION',
  R_OPER_PCI_DOCUMENTATION: 'R_OPER_PCI_DOCUMENTATION',
  R_OPER_PCI_ANTIGA: 'R_OPER_PCI_ANTIGA',
  RW_OPER_PCI_ARCHIVE_WORKS: 'RW_OPER_PCI_ARCHIVE_WORKS',
  RW_OPER_PCI_ARCHIVE_FINANCE: 'RW_OPER_PCI_ARCHIVE_FINANCE',
  RW_OPER_PCI_REPORT: 'RW_OPER_PCI_REPORT',
  /** @description Rel. Acomp. Telecom -- cadastro dos dados fixos (empresa, contrato, RMR, fatores). */
  RW_OPER_PCI_RELACOMP_FIXO: 'RW_OPER_PCI_RELACOMP_FIXO',
  /** @description Rel. Acomp. Telecom -- gerar o relatorio (.xlsx), sem acesso ao cadastro. */
  RW_OPER_PCI_RELACOMP_GERAR: 'RW_OPER_PCI_RELACOMP_GERAR',

  RW_OPER_PCI_COP_COORD: 'RW_OPER_PCI_COP_COORD',
  RW_OPER_PCI_COP_ITEM_DEL: 'RW_OPER_PCI_COP_ITEM_DEL',

  RW_OPER_GDOCS: 'RW_OPER_GDOCS',
  R_OPER_GDOCS: 'R_OPER_GDOCS',
  RW_OPER_GDOCS_MOVE: 'RW_OPER_GDOCS_MOVE',

  RW_OPER_PCI_PDR: 'RW_OPER_PCI_PDR',
  RW_OPER_PCI_PDR_BONUS: 'RW_OPER_PCI_PDR_BONUS',
  RW_OPER_PCI_PDR_TECNICAL: 'RW_OPER_PCI_PDR_TECNICAL',
  RW_OPER_PCI_PDR_ENGINEERING: 'RW_OPER_PCI_PDR_ENGINEERING',
  RW_OPER_PCI_PDR_EXCLUSION: 'RW_OPER_PCI_PDR_EXCLUSION',
  RW_OPER_PCI_PDR_PAYMENT: 'RW_OPER_PCI_PDR_PAYMENT',
  RW_OPER_PCI_PDR_REPORT: 'RW_OPER_PCI_PDR_REPORT',
  R_OPER_PCI_PDR_VALUES: 'R_OPER_PCI_PDR_VALUES',
  RW_OPER_PCI_PDR_NA: 'RW_OPER_PCI_PDR_NA',
  RW_OPER_PCI_PDR_NA_DELETE: 'RW_OPER_PCI_PDR_NA_DELETE',
  R_OPER_PCI_PDR_ARCHIVED: 'R_OPER_PCI_PDR_ARCHIVED',

  // PDR novo (satelite, login pelo zcloud). O PDR traduz o papel nas permissoes dele; o escopo
  // (TELECOM/TRADICIONAL) e separado. Os RW_OPER_PCI_PDR* acima tambem valem la, com escopo telecom.
  RW_OPER_PDR: 'RW_OPER_PDR',
  RW_OPER_PDR_ADMIN: 'RW_OPER_PDR_ADMIN',
  RW_OPER_PDR_ABERTURA: 'RW_OPER_PDR_ABERTURA',
  RW_OPER_PDR_REVISAO: 'RW_OPER_PDR_REVISAO',
  RW_OPER_PDR_REVISAO_DIRETOR: 'RW_OPER_PDR_REVISAO_DIRETOR',
  RW_OPER_PDR_VALORES: 'RW_OPER_PDR_VALORES',
  RW_OPER_PDR_APROVACAO: 'RW_OPER_PDR_APROVACAO',
  RW_OPER_PDR_PAGAMENTO: 'RW_OPER_PDR_PAGAMENTO',
  RW_OPER_PDR_TELECOM: 'RW_OPER_PDR_TELECOM',
  RW_OPER_PDR_TRADICIONAL: 'RW_OPER_PDR_TRADICIONAL',

  RW_OPER_PCI_AT_LPU: 'RW_OPER_PCI_AT_LPU',
  RW_OPER_PCI_AT_REGIONAL: 'RW_OPER_PCI_AT_REGIONAL',
  RW_OPER_PCI_AT_EXTRA: 'RW_OPER_PCI_AT_EXTRA',
  RW_OPER_PCI_AT_PLAN: 'RW_OPER_PCI_AT_PLAN',
  RW_OPER_PCI_AT_BUDGET: 'RW_OPER_PCI_AT_BUDGET',
  RW_OPER_PCI_AT_MANAGER: 'RW_OPER_PCI_AT_MANAGER',
  RW_OPER_PCI_AT_DIRECTOR: 'RW_OPER_PCI_AT_DIRECTOR',
  R_OPER_PCI_AT_READ: 'R_OPER_PCI_AT_READ',

  RW_OPER_DOC_ROOT_FOLDERS: 'RW_OPER_DOC_ROOT_FOLDERS',
  RW_OPER_DOC_SETTINGS: 'RW_OPER_DOC_SETTINGS',

  RW_OPER_ACQ: 'RW_OPER_ACQ',
  RW_OPER_ACQ_ADMIN: 'RW_OPER_ACQ_ADMIN',

  RW_OPER_MOI: 'RW_OPER_MOI',
  RW_OPER_MOI_EXTERNO: 'RW_OPER_MOI_EXTERNO',
  RW_OPER_MOI_ADMIN: 'RW_OPER_MOI_ADMIN',

  RW_OPER_CTRL: 'RW_OPER_CTRL',
  RW_OPER_CTRL_EXTERNO: 'RW_OPER_CTRL_EXTERNO',
  RW_OPER_CTRL_APROV: 'RW_OPER_CTRL_APROV',
  RW_OPER_CTRL_ADMIN: 'RW_OPER_CTRL_ADMIN',
  // ZGedCon (gestão de contratos). Só a de MENU mora aqui: ela libera o link e concede ZERO
  // dentro do ZGedCon. Quem trabalha precisa de um segundo perfil (RW_OPER_ZGEDCON_APROV ou
  // RW_OPER_ZGEDCON_ADMIN), que o zcloud não conhece — quem traduz é o upstream.ts do
  // zgedcon-backend. Mesmo arranjo do RW_OPER_ZCURRICULO.
  RW_OPER_ZGEDCON: 'RW_OPER_ZGEDCON',

  // zCurriculo (ATS). Só a de MENU mora aqui: ela libera o link e concede ZERO no zCurriculo.
  // Quem trabalha precisa de um segundo perfil (RW_OPER_ZCUR_RECRUT, _SOLIC ou _ADMIN), que o
  // zcloud não conhece — quem traduz é o roles.ts do zcurriculo-backend.
  RW_OPER_ZCURRICULO: 'RW_OPER_ZCURRICULO',
  // Sistema de Gestão (SG): a genérica libera o link; ADMIN/DIRETOR são traduzidos pelo niveis.ts do SG.
  RW_OPER_SG: 'RW_OPER_SG',
  RW_OPER_SG_DIRETOR: 'RW_OPER_SG_DIRETOR',
  RW_OPER_SG_ADMIN: 'RW_OPER_SG_ADMIN',
  // Os perfis de trabalho do zCurriculo entram aqui SÓ para o menu RH escolher os itens (Gestão de
  // Vagas e Departamento Pessoal). O que cada um concede continua no roles.ts do zcurriculo-backend.
  // Duas famílias desde a task 184 do zCurriculo (2026-10-08): RH (Gestão de Vagas, RW_OPER_ZCUR_*)
  // e DP (RW_OPER_DP_*).
  RW_OPER_ZCUR_ADMIN: 'RW_OPER_ZCUR_ADMIN',
  RW_OPER_ZCUR_RECRUT: 'RW_OPER_ZCUR_RECRUT',
  RW_OPER_ZCUR_SOLIC: 'RW_OPER_ZCUR_SOLIC',
  RW_OPER_DP_ADMISSAO: 'RW_OPER_DP_ADMISSAO',
  RW_OPER_DP_OBRA: 'RW_OPER_DP_OBRA',
  RW_OPER_DP_ARQUIV: 'RW_OPER_DP_ARQUIV',
  RW_OPER_DP_FERIAS: 'RW_OPER_DP_FERIAS',
  RW_OPER_DP_RESCISAO: 'RW_OPER_DP_RESCISAO',
  // Nomes antigos dos perfis do DP, só para a janela da troca no aceite (a migration
  // 20261008180000_PERFIS_RH_E_DP renomeia). Saem quando nenhuma conta tiver mais a funcao antiga.
  RW_OPER_ZCUR_INCLUI: 'RW_OPER_ZCUR_INCLUI',
  RW_OPER_ZCUR_DPOBRA: 'RW_OPER_ZCUR_DPOBRA',
  RW_OPER_ZCUR_ARQUIV: 'RW_OPER_ZCUR_ARQUIV',
  RW_OPER_ZCUR_FERIAS: 'RW_OPER_ZCUR_FERIAS',
  RW_OPER_ZCUR_RESCIS: 'RW_OPER_ZCUR_RESCIS',

  /** @description REAL_ESTA - USUÁRIOS */
  RW_REAL_ESTA_USERS: 'RW_REAL_ESTA_USERS',

  ACC_COMPANY_ZOPONE: 'ACC_COMPANY_ZOPONE',
  ACC_COMPANY_AGR: 'ACC_COMPANY_AGR',
  ACC_COMPANY_ZPAV: 'ACC_COMPANY_ZPAV',
  ACC_COMPANY_ABDA: 'ACC_COMPANY_ABDA',
  ACC_COMPANY_ZINC: 'ACC_COMPANY_ZINC',
  ACC_COMPANY_AGUAAZUL: 'ACC_COMPANY_AGUAAZUL',
  ACC_COMPANY_TERRAFLORA: 'ACC_COMPANY_TERRAFLORA',
  ACC_COMPANY_CHILE: 'ACC_COMPANY_CHILE',
  ACC_COMPANY_ZSITES: 'ACC_COMPANY_ZSITES',
  ACC_COMPANY_LAGUARDIA: 'ACC_COMPANY_LAGUARDIA',
  ACC_COMPANY_VILLALEON: 'ACC_COMPANY_VILLALEON',
  ACC_COMPANY_ZIMOVEIS: 'ACC_COMPANY_ZIMOVEIS',
  ACC_COMPANY_LAGOS: 'ACC_COMPANY_LAGOS',
  ACC_COMPANY_HARAS: 'ACC_COMPANY_HARAS',
  ACC_COMPANY_JRZ: 'ACC_COMPANY_JRZ',
  ACC_COMPANY_CZ: 'ACC_COMPANY_CZ',
  ACC_COMPANY_RODOVIA: 'ACC_COMPANY_RODOVIA',
  ACC_COMPANY_VILLALEON2: 'ACC_COMPANY_VILLALEON2',
  ACC_COMPANY_ZMAIS: 'ACC_COMPANY_ZMAIS',
  ACC_COMPANY_3Z: 'ACC_COMPANY_3Z',
  ACC_COMPANY_5Z: 'ACC_COMPANY_5Z',
  ACC_COMPANY_6Z: 'ACC_COMPANY_6Z',
  ACC_COMPANY_7Z: 'ACC_COMPANY_7Z',
  ACC_COMPANY_9Z: 'ACC_COMPANY_9Z',
  ACC_COMPANY_10Z: 'ACC_COMPANY_10Z',
  ACC_COMPANY_ACRE: 'ACC_COMPANY_ACRE',
  ACC_COMPANY_ACRE2: 'ACC_COMPANY_ACRE2',
  ACC_COMPANY_RIOMINAS: 'ACC_COMPANY_RIOMINAS',
  ACC_COMPANY_AMAPARPARA: 'ACC_COMPANY_AMAPARPARA',
  ACC_COMPANY_AMAPAR2: 'ACC_COMPANY_AMAPAR2',
  ACC_COMPANY_LUZPED: 'ACC_COMPANY_LUZPED',
  ACC_COMPANY_LUZFR: 'ACC_COMPANY_LUZFR',
  ACC_COMPANY_LUZMOG: 'ACC_COMPANY_LUZMOG',
  ACC_COMPANY_ZR1: 'ACC_COMPANY_ZR1',
  ACC_COMPANY_ZR2: 'ACC_COMPANY_ZR2',
  ACC_COMPANY_ZR3: 'ACC_COMPANY_ZR3',
  ACC_COMPANY_ZR5: 'ACC_COMPANY_ZR5',
  ACC_COMPANY_ZR6: 'ACC_COMPANY_ZR6',
  ACC_COMPANY_ZR11: 'ACC_COMPANY_ZR11',
  ACC_COMPANY_ROTAPRODUCAO: 'ACC_COMPANY_ROTAPRODUCAO',
  ACC_COMPANY_VALEARINOS: 'ACC_COMPANY_VALEARINOS',
  ACC_COMPANY_12Z: 'ACC_COMPANY_12Z',
  ACC_COMPANY_LUZBAURU: 'ACC_COMPANY_LUZBAURU',
  ACC_COMPANY_ZR12: 'ACC_COMPANY_ZR12',
  ACC_COMPANY_LUZAGUDOS: 'ACC_COMPANY_LUZAGUDOS',
  ACC_COMPANY_LUZSAOMANUEL: 'ACC_COMPANY_LUZSAOMANUEL',
  ACC_COMPANY_LUZJABOTICABAL: 'ACC_COMPANY_LUZJABOTICABAL',
  ACC_COMPANY_JRZPAINEIRAS: 'ACC_COMPANY_JRZPAINEIRAS',
  /** @description OPER - VISTORIA */
  ACC_SURVEY: 'ACC_SURVEY',

  /** @description REALESTATE - ADMINISTRADOR */
  RW_REAL_ESTA_ADMIN: 'RW_REAL_ESTA_ADMIN',
  /** @description REALESTATE - CREDECIADA */
  RW_REAL_ESTA_CRED: 'RW_REAL_ESTA_CRED',
  /** @description REALESTATE - COORDENADOR OBRA */
  RW_REAL_ESTA_ADMIN_OBRA: 'RW_REAL_ESTA_ADMIN_OBRA',
  /** @description REALESTATE - COORDENADOR OBRA */
  RW_REAL_ESTA_COORD_OBRA: 'RW_REAL_ESTA_COORD_OBRA',
  /** @description REALESTATE - COORDENADOR OBRA */
  RW_REAL_ESTA_USER_OBRA: 'RW_REAL_ESTA_USER_OBRA',

  /** @description FIN - REEMBOLSO VIAGEM */
  RW_FIN_TRAVELREFUND: 'RW_FIN_TRAVELREFUND',
  /** @description AFIN - DESPESAS VIAGEM */
  RW_FIN_TRAVELEXPENSES: 'RW_FIN_TRAVELEXPENSES',
  /** @description FIN - DESPESAS DIVERSOS */
  RW_FIN_MISCELLANEOUS: 'RW_FIN_MISCELLANEOUS',
  /** @description FIN - REEMBOLSO VIAGEM - TAB TERMO */
  RW_FIN_TRAVELREFUND_TERM: 'RW_FIN_TRAVELREFUND_TERM',
  /** @description FIN - REEMBOLSO VIAGEM - TAB AUTORIZAÇÕES */
  RW_FIN_TRAVELREFUND_AUTHORIZATIONS: 'RW_FIN_TRAVELREFUND_AUTHORIZATIONS',
  /** @description FIN - REEMBOLSO VIAGEM - TAB PESQUISAR */
  RW_FIN_TRAVELREFUND_SEARCH: 'RW_FIN_TRAVELREFUND_SEARCH',
  /** @description FIN - REEMBOLSO VIAGEM - TAB DETALHES */
  RW_FIN_TRAVELREFUND_DETAILS: 'RW_FIN_TRAVELREFUND_DETAILS',
  /** @description FIN - REEMBOLSO VIAGEM - AUTORIZAÇÕES - APROVAR && REPROVAR */
  ACC_FIN_TRAVELREFUND_AUTH_APRROVE: 'ACC_FIN_TRAVELREFUND_AUTH_APRROVE',
  /** @description FIN - REEMBOLSO VIAGEM - APROVAÇÃO RESPONSÁVEL OBRA */
  ACC_FIN_TRAVELREFUND_SEARCH_WORK_APPROVAL: 'ACC_FIN_TRAVELREFUND_SEARCH_WORK_APPROVAL',
  /** @description FIN - REEMBOLSO VIAGEM - APROVAÇÃO CONTROLADORIA */
  ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL: 'ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL',
  /** @description FIN - REEMBOLSO VIAGEM - APROVAÇÃO ADMINISTRADOR OBRA */
  ACC_FIN_TRAVELREFUND_SEARCH_ADMIN_APPROVAL: 'ACC_FIN_TRAVELREFUND_SEARCH_ADMIN_APPROVAL',
  /** @description FIN - REEMBOLSO VIAGEM - APROVAÇÃO DIRETORIA */
  ACC_FIN_TRAVELREFUND_SEARCH_BOARD_APPROVAL: 'ACC_FIN_TRAVELREFUND_SEARCH_BOARD_APPROVAL',
  /** @description FIN - REEMBOLSO VIAGEM - APROVADO */
  ACC_FIN_TRAVELREFUND_SEARCH_APPROVED: 'ACC_FIN_TRAVELREFUND_SEARCH_APPROVED',
  /** @description FIN - REEMBOLSO VIAGEM - PAGAMENTO REALIZADO */
  ACC_FIN_TRAVELREFUND_SEARCH_PAYMENT_MADE: 'ACC_FIN_TRAVELREFUND_SEARCH_PAYMENT_MADE',
  /** @description FIN - DESPESAS VIAGEM - APROVAÇÃO COORDENADOR */
  ACC_FIN_TRAVELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL: 'ACC_FIN_TRAVELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL',
  /** @description FIN - DESPESAS VIAGEM - APROVAÇÃO CONTROLADORIA */
  ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL: 'ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL',
  /** @description FIN - DESPESAS VIAGEM - APROVAÇÃO TECNICO */
  ACC_FIN_TRAVELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL: 'ACC_FIN_TRAVELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL',
  /** @description FIN - DESPESAS DIVERSOS - APROVAÇÃO COORDENADOR */
  ACC_FIN_MISCELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL: 'ACC_FIN_MISCELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL',
  /** @description FIN - DESPESAS DIVERSOS - APROVAÇÃO CONTROLADORIA */
  ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL: 'ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL',
  /** @description FIN - DESPESAS DIVERSOS - APROVAÇÃO TECNICO */
  ACC_FIN_MISCELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL: 'ACC_FIN_MISCELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL',
  /** @description FIN – DESPESAS VIAGEM – APROVAÇÃO COORDENADOR MATRIZ */
  ACC_FIN_TRAVELCOORDINATOR_CENTRAL_LANEOUS_SEARCH_CONTROLLER_APPROVAL: 'ACC_FIN_TRAVELCOORDINATOR_CENTRAL_LANEOUS_SEARCH_CONTROLLER_APPROVAL',
  /** @description FIN – REEMBOLSO VIAGEM – APROVAÇÃO COORDENADOR */
  ACC_FIN_TRAVELREFUND_COORDINATOR_SEARCH_CONTROLLER_APPROVAL: 'ACC_FIN_TRAVELREFUND_COORDINATOR_SEARCH_CONTROLLER_APPROVAL',
  /** @description APR – ADMINISTRADOR */
  APR_SEARCH_CONTROLLER_APPROVAL: 'APR_SEARCH_CONTROLLER_APPROVAL',
  /** @description APR – TECNICO */
  APR_RESEARCH_TECHNICIAN_VIEW: 'APR_RESEARCH_TECHNICIAN_VIEW',
  /** @description APR - MENU (funcao no banco: APR_MENU) */
  MENU_APR: 'APR_MENU',
  /** @description APR - ENGENHEIRO */
  APR_RESEARCH_TECHNICAL_ENGINEER_VIEW: 'APR_RESEARCH_TECHNICAL_ENGINEER_VIEW',
  /** @description APR - SUPERVISOR */
  APR_RESEARCH_MASTER_IN_CHARGE_VIEW: 'APR_RESEARCH_MASTER_IN_CHARGE_VIEW',
  /** @description APR - COORDENADOR */
  APR_COORDINATOR_APPROVAL: 'APR_COORDINATOR_APPROVAL',
  /** @description QMA - MENU (funcao no banco: QMA_MENU) */
  MENU_QMA: 'QMA_MENU',
  /** @description QMA – TECNICO */
  QMA_RESEARCH_TECHNICIAN_VIEW: 'QMA_RESEARCH_TECHNICIAN_VIEW',
  /** @description QMA - ENGENHEIRO */
  QMA_RESEARCH_TECHNICAL_ENGINEER_VIEW: 'QMA_RESEARCH_TECHNICAL_ENGINEER_VIEW',
  /** @description QMA - SUPERVISOR */
  QMA_RESEARCH_MASTER_IN_CHARGE_VIEW: 'QMA_RESEARCH_MASTER_IN_CHARGE_VIEW',
  /** @description QMA - ADMINISTRADOR */
  QMA_SEARCH_CONTROLLER_APPROVAL: 'QMA_SEARCH_CONTROLLER_APPROVAL',

  // ---- Reorganizacao de modulos (migration 20260821120000). Convivem com as antigas:
  // o v-if e o expectedRoles aceitam `nova || antiga` ate a virada terminar. ----

  /** @description MENU IMOBILIARIA (IMOB) */
  MENU_IMOB: 'MENU_IMOB',
  /** @description IMOB - CADASTROS */
  RW_IMOB_CADASTROS: 'RW_IMOB_CADASTROS',
  /** @description IMOB - VENDAS */
  RW_IMOB_VENDAS: 'RW_IMOB_VENDAS',
  /** @description IMOB - COMISSOES */
  RW_IMOB_COMISSOES: 'RW_IMOB_COMISSOES',
  /** @description IMOB - RELATORIOS */
  RW_IMOB_RELATORIOS: 'RW_IMOB_RELATORIOS',

  /** @description MENU OBRAS (OCO) */
  MENU_OBRAS: 'MENU_OBRAS',
  /** @description OCO - OBRAS - ADMINISTRADOR */
  RW_OBRAS_ADMIN: 'RW_OBRAS_ADMIN',
  /** @description OCO - OBRAS - COORDENADOR OBRA */
  RW_OBRAS_COORD: 'RW_OBRAS_COORD',
  /** @description OCO - OBRAS - USUARIO */
  RW_OBRAS_USER: 'RW_OBRAS_USER',

  /** @description MENU Z PAG (FIN) */
  MENU_ZPAG: 'MENU_ZPAG',
  /** @description FIN - Z PAG - DESPESA VIAGEM */
  RW_ZPAG_VIAGEM: 'RW_ZPAG_VIAGEM',
  /** @description FIN - Z PAG - DESPESA VIAGEM - CONSULTA */
  ACC_ZPAG_VIAGEM_CONSULTA: 'ACC_ZPAG_VIAGEM_CONSULTA',
  /** @description FIN - Z PAG - DESPESA DIVERSOS */
  RW_ZPAG_DIVERSOS: 'RW_ZPAG_DIVERSOS',
  /** @description FIN - Z PAG - DESPESA DIVERSOS - CONSULTA */
  ACC_ZPAG_DIVERSOS_CONSULTA: 'ACC_ZPAG_DIVERSOS_CONSULTA',
  /** @description FIN - Z PAG - REEMBOLSO VIAGEM */
  RW_ZPAG_REEMBOLSO: 'RW_ZPAG_REEMBOLSO',
  /** @description FIN - Z PAG - PRESTACAO DE CONTAS */
  RW_ZPAG_PRESTACAO: 'RW_ZPAG_PRESTACAO',
  /** @description FIN - Z PAG - QUADRO FUNCIONARIOS */
  RW_ZPAG_QUADRO: 'RW_ZPAG_QUADRO',

  /** @description MEU Z - USUARIO MESTRE (era RW_REAL_ESTA_MAST; migration 20260821120200) */
  RW_MEUZ_MASTER: 'RW_MEUZ_MASTER',

  /** @description APR - ADMINISTRADOR DO MODULO (migration 20260821120300).
   *  Substitui o emprestimo de RW_REAL_ESTA_ADMIN nas 4 telas do APR. Nao confundir com
   *  APR_SEARCH_CONTROLLER_APPROVAL, que e o aprovador do fluxo. */
  RW_APR_ADMIN: 'RW_APR_ADMIN',

  /** @description QMA - COORDENADOR */
  QMA_COORDINATOR_APPROVAL: 'QMA_COORDINATOR_APPROVAL'
}
export default roles



// WEBPACK FOOTER //
// ./src/shared/utils/roles.js